// @flow

import {
  SPATIAL,
  EDITING_SPATIAL,
  IS_EDITING,
  ACTIVE_TOOLS_OP,
} from './constants'

export default {
  [SPATIAL]: {},
  [EDITING_SPATIAL]: null,
  [IS_EDITING]: false,
  [ACTIVE_TOOLS_OP]: false,
}
